export default {
  system: {
    user: '사용자',
    level: '레벨',
    earnPerTap: '탭당 수익',
    coinsToLevelUp: '레벨업에 필요한 코인',
    profitPerHour: '시간당 수익',
    coming1: '곧 여기에',
    coming2: '흥미로운 것이 추가됩니다...',
    close: '닫기',
    friends: '친구',
    continue: '계속하기',
  },
  settings: {
    chooseNetwork: '네트워크 선택',
    chooseLanguage: '언어 선택',
  },
  popup_CheckTask: {
    join: '가입하기',
    check: '확인하기',
    taskIsNotCompleted: '작업이 완료되지 않았습니다',
  },
  popup_levelUp: {
    levelUp: '레벨 업!',
    multiTap: '멀티탭',
    energyLimit: '에너지 한도',
  },
  popup_BalanceUp: {
    balanceUp: '잔액 업데이트!',
    balanceDiffSinceLast: '당신의 보상',
  },
  popup_BalanceTip: {
    tip: '수익을 높이세요',
    message: '마인 메뉴를 탭하여 네트워크 업그레이드를 구매하세요',
    description: '오프라인에서도 최대 3시간까지 수익을 얻을 수 있습니다',
  },
  popup_Bored: {
    header: '개구리가 지루해합니다!',
    message: '개구리와 놀아주세요.',
    description: '개구리와 3시간 동안 놀아주지 않으면 수익이 중단됩니다',
  },
  popup_Hungry: {
    header: '개구리가 배고파합니다!',
    message: '개구리에게 먹이를 주세요.',
    description: '친구가 많을수록 먹이 주기마다 더 많은 코인을 얻을 수 있습니다',
  },
  menu: {
    network: '네트워크',
    mine: '마인',
    earn: '수익',
    food: '먹이',
  },
  tap: {
    bored: '지루한',
    fun: '재미있는',
  },
  mineMenu: {
    activities: '활동',
    investments: '투자',
    web3: 'WEB3',
    achievements: '업적',
  },
  leaderboard: {
    from: '부터',
    beTheFirst: '첫 번째가 되세요!',
  },
  mine: {
    joinOurTG1: '우리의 텔레그램 채널에 가입하세요,',
    joinOurTG2: '잠금을 해제하려면!',
    unlock: '잠금 해제',
  },
  friends: {
    inviteFriends: '친구를 초대하세요!',
    receiveBonuses: '당신과 당신의 친구가 보너스를 받게 됩니다',
    inviteFriend: '친구 초대하기',
    withTelegramPremium: '텔레그램 프리미엄으로',
    forYouAndYourFriend: '당신과 당신의 친구를 위해',
    moreBonuses: '더 많은 보너스',
    listOfYourFriends: '친구 목록',
    linkCopied: '초대 링크가 클립보드에 복사되었습니다!',
    playWithMe:
      '저와 함께 플레이하고 에어드롭을 통해 토큰을 획득하세요!\n' +
      '💰 선물을 받으세요! 신규 가입자에게 +3000 코인\n' +
      '🚀 텔레그램 프리미엄이 있나요? +5000 코인을 받으세요!\n',
  },
  earn: {
    moreCoins: '더 많은 코인을 획득하세요!',
    dailyTasks: '일일 과제',
    dailyReward: '일일 보상',
    tasksList: '과제 목록',
    joinOurTG: '우리의 텔레그램 채널에 가입하세요',
    followOurX: '우리의 X 계정을 팔로우하세요',
    yourAd: '여기에 당신의 광고가 표시될 수 있습니다',
    connect: '우리 텔레그램 채널의 관리자에게 연락하세요',
  },
  food: {
    hungry: '배고픔',
    full: '배부름',
    frogIsFull: '개구리가 배불러요',
    feed: '먹이 주기',
    bonus: '보너스',
    satiety: '포만감',
    hours: '시간',
  },
  toast: {
    buyCard: {
      title: '업적 달성!',
      subtitle: '당신의 개구리 제국을 위대함으로 이끌 시간입니다 👑',
    },
    feedFrog: {
      title: '개구리가 행복해요!',
      subtitle: '잘 했어요! 계속 웃음을 유지하려면 반려동물에게 먹이를 주세요 🍽️',
    },
  },
};
